import { SpaRouterError } from './spa-router.error';
export class WindowEventConsolidationError extends SpaRouterError {
    constructor(message) {
        super(message);
        this.name = 'WindowEventConsolidationError';
    }
}
